import React, { useState, useContext, useRef, useEffect } from 'react'
import { withRouter } from 'react-router-dom'
import { Link, NavLink } from 'react-router-dom'
import { object, string, array } from 'prop-types'
import MobileHeaderButton from '../subComponents/MobileHeaderButton'
import MobileHeaderItem from '../subComponents/MobileHeaderItem'
import { AuthContext, GlobalContext } from '../../services/context'
import { Button } from 'syngenta-react-components'
import useBreakpoint from '../../dpe-usco/services/useBreakpoint'
import { getHighestRole } from '../../services/apiHelper'


const Header = props => {
  const { auth, authDispatch, hasAccess } = useContext(AuthContext)
  const { state, dispatch, trackEvent } = useContext(GlobalContext)
  const [showReports, setShowReports] = useState(false)
  const [breakpoint] = useBreakpoint()
  const viewIsSmallOrMobile = breakpoint === 'small' || breakpoint === 'mobile'
  const [open, setOpen] = useState(false)

  const canceled = useRef(false)
  useEffect(() => {
    getHighestRole()?.then(res => {
      if(res && res.permissions && res.permissions.includes('show-reports')){
        setShowReports(true)
      } else{
        setShowReports(false)
      }
    })
  
    return () => {
      canceled.current = true
    }
  }, [state?.userPermission?.hasChanged])

  const handleHeaderButtonClick = title => {
    if (!canceled.current) {
      trackEvent(`${title}_clicked`)
    }
  }

  const pushSearch = e => {
    e.preventDefault()
    dispatch({ type: 'GO_TO_SEARCH' })
    trackEvent('search_clicked')
  }

  const logOut = e => {
    e.preventDefault()
    trackEvent('user_logged_out')
    authDispatch({ type: 'LOG_OUT' })
  }

  const createNavLink = entry => {
    const entryContainsPeople = entry.path.includes('/people')
    const propsContainsPeople = props.location.pathname.includes('/people')

    let linkClass = 'dib mr32 tdn c-black'
    linkClass =
      (entryContainsPeople && propsContainsPeople) ||
      entry.path === props.location.pathname
        ? `${linkClass} fw700`
        : linkClass
    let showNav = true
    if(entry.title === 'reports' && !showReports) {
      showNav = false
    }
    if(showNav) {
      if (hasAccess() === 'SUCCESS') {
        return (
          <Link
            key={entry.title}
            to={entry.path}
            className={linkClass}
            onClick={() => handleHeaderButtonClick(entry.title)}
          >
            {entry.displayName}
          </Link>
        )
      } else {
        return entry.title !== 'admin' ? (
          <Link
            key={entry.title}
            to={entry.path}
            className={linkClass}
            onClick={() => handleHeaderButtonClick(entry.title)}
          >
            {entry.displayName}
          </Link>
        ) : null
      }
    }
  }

  const goToUser = e => {
    e.preventDefault()
    trackEvent('username_clicked')
    dispatch({
      type: 'GO_TO_USER_DETAIL',
      payload: { company_id: 'ANY', id: auth.userInfo.user_id }
    })
  }

  const generateMenuItems = routes => {
    return (
      <React.Fragment>
        {routes.map(val => {
          return (
            <MobileHeaderItem
              open={open}
              setOpen={setOpen}
              path={val.path}
              key={val.title}
              onClick={() => handleHeaderButtonClick(val.title)}
            >
              {val.displayName}
            </MobileHeaderItem>
          )
        })}
        <MobileHeaderItem
          open={open}
          setOpen={setOpen}
          path={'/search'}
          onClick={pushSearch}
          key={'Search'}
        >
          {'Search'}
        </MobileHeaderItem>
        <MobileHeaderItem
          open={open}
          setOpen={setOpen}
          path={`company/ANY/user/${auth.userInfo?.user_id}`}
          onClick={goToUser}
          key={'UserFirstAndUserLast'}
        >
          {auth.userInfo?.first &&
            auth.userInfo?.last &&
            `${auth.userInfo.first} ${auth.userInfo.last}`}
        </MobileHeaderItem>
        <MobileHeaderItem
          open={open}
          setOpen={setOpen}
          path={''}
          onClick={logOut}
          key={'Logout'}
        >
          {'Logout'}
        </MobileHeaderItem>
      </React.Fragment>
    )
  }

  return (
    <div className="df w100% bb1-s-lightgray h60 jcsb aic mb25">
      <div className="ml10 df aic">
        {props.logoPath && (
          <img alt="logo" src={props.logoPath} className="fll mr64 w165 vam" />
        )}
        <span
          className={`posr t5 fz21 mr32 fw500 ${
            viewIsSmallOrMobile ? 'dn' : ''
          }`}
        >
          {auth.loggedIn === 'SUCCESS' &&
            props.routes &&
            props.routes.map(route => createNavLink(route))}
        </span>
      </div>
      {auth.loggedIn === 'SUCCESS' && (
        <div className={`aic posr t5 ${viewIsSmallOrMobile ? 'dn' : 'df'}`}>
          {hasAccess('ANY', 'read-company') === 'SUCCESS' ? (
            <a href="/search" onClick={pushSearch}>
              <Button styleType="success" customClassName="mr10">
                Search
              </Button>
            </a>
          ) : null}
          <a
            href={`company/ANY/user/${auth.userInfo?.user_id}`}
            className="mr32 fz16"
            onClick={goToUser}
          >
            {auth.userInfo?.first &&
              auth.userInfo?.last &&
              `${auth.userInfo.first} ${auth.userInfo.last}`}
          </a>
          <NavLink
            className="c-darkgray mr32 fw600 tdn"
            to="#"
            onClick={logOut}
          >
            Log out
          </NavLink>
        </div>
      )}
      <div className={`mr10 curp ${!viewIsSmallOrMobile ? 'dn' : ''}`}>
        <MobileHeaderButton open={open} setOpen={setOpen} />
        {
          <div
            className={`mobile-menu mt60 bgc-white z2 w100vw fxdrc df posa t0 l0 fz20 ${
              open ? 'hfit' : 'h0'
            }`}
          >
            {generateMenuItems(props.routes)}
          </div>
        }
      </div>
    </div>
  )
}

export default withRouter(Header)

Header.propTypes = {
  location: object,
  logoPath: string,
  routes: array.isRequired,
  profilePath: object
}
